// extracted by mini-css-extract-plugin
export default {"root":"GWaj8","transform":"_1H5zM","swipeable":"_3jjwM","preview":"_30e0-","next":"_2pd7V","prev":"yrydH"};